module.exports = __webpack_public_path__ + "static/img/yaluanwan.d623331.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/yaluanwan.png
// module id = kAzm
// module chunks = 52